import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

// Check more icons at https://react-icons.github.io/react-icons/icons?name=fa
import { FaSignInAlt } from 'react-icons/fa'

import {
    CustomTabBar, RoomsAdmin, ParkingAdmin, EventsAdmin, NotificationsAdmin
} from '../components/Admin'

import { LOGOUT_TEXT, ADMINISTRATION_HEADER } from '../strings'


class Admin extends Component {

    constructor(props){
        super(props)

        this.state = {
            activeTab: 0
        }
        this.handleTabUpdate = this.handleTabUpdate.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
    }

    handleTabUpdate(activeTab){
        this.setState({
            activeTab: activeTab
        })
    }

    handleLogout(){
        localStorage.clear()
        this.props.history.push('/login')
    }

    render(){
        const {activeTab} = this.state
        const {handleTabUpdate, handleLogout} = this
        return(
            <div>
                <div class="topnav">
                    <label>{ADMINISTRATION_HEADER}</label>
                    <label type="button" className={"inactive"} onClick={handleLogout} ><FaSignInAlt/>{LOGOUT_TEXT}</label>
                </div>
                <CustomTabBar
                    handleActiveIndexUpdate={handleTabUpdate}
                    activeTab={activeTab}
                />
                {
                    activeTab === 0 ?
                    <div className="admin-tab-container">
                        <NotificationsAdmin />
                    </div> :
                    activeTab === 1 ?
                    <div className="admin-tab-container">
                        <RoomsAdmin />
                    </div>:
                    activeTab === 2 ?
                    <div className="admin-tab-container">
                        <ParkingAdmin />
                    </div>:
                    activeTab === 3 ?
                    <div className="admin-tab-container">
                        <EventsAdmin />
                    </div> :
                    <div className="admin-tab-container"></div>
                }
                <div></div>
            </div>
        )
    }
}

export default withRouter(Admin)
